module.exports = __webpack_public_path__ + "static/img/アセット 25@2x.3c7ae81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 25@2x.png
// module id = baW+
// module chunks = 1